import * as React from 'react';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import {
	useLazyQuestionnaireBasicInfoQuery,
	useLazyQuestionnaireSearchQuery,
} from '../../../../graphql/graphql';
import { FieldError } from 'react-hook-form';
import DynamicSelect from '../../../../Components/Base/DynamicSelect/DynamicSelect';
import { useEffectAsync } from '../../../../helpers';

interface QuestionnaireSelectProps {
	onChange?: (value: SelectValue) => void;
	value?: SelectValue;
	error?: FieldError;
}

const QuestionnaireCodeSelect: React.FC<QuestionnaireSelectProps> = props => {
	const { value, onChange } = props;
	const [searchQuestionnaire] = useLazyQuestionnaireSearchQuery();
	const [getQuestionnaireInfo] = useLazyQuestionnaireBasicInfoQuery();

	useEffectAsync(async () => {
		if (value?.value && !value?.label) {
			const { questionnaire } = await getQuestionnaireInfo({
				id: value.value,
			}).unwrap();
			if (questionnaire?.title && questionnaire.code) {
				const newValue = {
					value: questionnaire.code,
					label: questionnaire.title,
				};

				onChange?.(newValue);
			}
		}
	});

	const handleSearchItem = async (
		searchInput: string,
	): Promise<SelectValue[]> => {
		const { questionnaires } = await searchQuestionnaire({
			fulltext: searchInput,
			take: 20,
			showHidden: true,
		}).unwrap();

		const items: SelectValue[] = [];

		for (const questionnaire of questionnaires?.data || []) {
			if (questionnaire?.code && questionnaire?.title) {
				if (
					!items.some(
						item =>
							item.label === questionnaire.title ||
							item.value === questionnaire.code,
					)
				) {
					items.push({
						value: questionnaire.code,
						label: questionnaire.title,
					});
				}
			}
		}

		return items;
	};

	return (
		<>
			<DynamicSelect
				searchItems={handleSearchItem}
				{...props}
				onChange={onChange}
				value={value}
				portal
			/>
		</>
	);
};

export default QuestionnaireCodeSelect;
